import React from "react";
import PropTypes from "prop-types";

export default function SidebarIcon({ name, size = 18, className }) {
    switch (name) {
        case "unreads":
            return (
                <svg viewBox="0 0 24 24" aria-hidden="true" width={size} height={size} className={className}>
                    <path fill="currentColor" d="M4 6h16a1 1 0 1 0 0-2H4a1 1 0 0 0 0 2zm0 7h12a1 1 0 1 0 0-2H4a1 1 0 0 0 0 2zm0 7h8a1 1 0 1 0 0-2H4a1 1 0 0 0 0 2z"/>
                </svg>
            );
        case "threads":
            return (
                <svg viewBox="0 0 24 24" aria-hidden="true" width={size} height={size} className={className}>
                    <path fill="currentColor" d="M4 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H9.6l-3.2 3.2A1 1 0 0 1 5 19.6V16H7a3 3 0 0 1-3-3V5z" opacity=".8"/>
                </svg>
            );
        case "drafts":
            return (
                <svg viewBox="0 0 24 24" aria-hidden="true" width={size} height={size} className={className}>
                    <path fill="currentColor" d="M3 12l18-9-9 18-1.8-6.2L3 12z"/>
                </svg>
            );
        case "search":
            return (
                <svg viewBox="0 0 24 24" aria-hidden="true" width={size} height={size} className={className}>
                    <path fill="currentColor" d="M11 4a7 7 0 105.196 12.196l3.854 3.854a1 1 0 001.415-1.415l-3.854-3.854A7 7 0 0011 4zm0 2a5 5 0 110 10 5 5 0 010-10z"/>
                </svg>
            );
        default:
            return null;
    }
}

SidebarIcon.propTypes = {
    name: PropTypes.oneOf(["unreads", "threads", "drafts", "search"]).isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
};


